import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormColor',
    props: {
        value: { default: "" },
        id: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const currentValue = computed({
            get() {
                return props.value;
            },
            set(newValue) {
                emit("input", newValue);
            },
        });
        return { __sfc: true, props, emit, currentValue };
    }
});
